export const radioBrazilian = {
  lunes: [
    {
      id: "brazilian-001",
      startTime: "07:20",
      endTime: "08:20",
      title: "Chill House",
      description: "House melódico para quienes siguen despiertos. Todo lo que se quieroda u mas",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/0-2/chill-house/cover.jpg"
    },
    {
      id: "brazilian-002",
      startTime: "17:22",
      endTime: "18:00",
      title: "Las Previas",
      color: "#ff6600",
      src: "https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
      cover: "../image/set/radioshow/008.jpg"
    },
    {
      id: "brazilian-003",
      startTime: "20:00",
      endTime: "22:00",
      title: "Invitado Especial",
      color: "#0059ff",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "../image/disco/virus.jpg"
    }
  ],
  martes: [
    {
      id: "brazilian-004",
      startTime: "00:00",
      endTime: "00:30",
      title: "GlitterTape - Camoufly",
      description: "House melódico para quienes siguen despiertos. Todo lo que se quieroda u mas",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/0-2/chill-house/cover.jpg"
    },
    {
      id: "brazilian-013",
      startTime: "21:25",
      endTime: "22:25",
      title: "Ripchord - Karan!",
      description: "Flow FanYYYYY",
      color: "#36bd36", /* 36bd36 */
      src: "https://dl.dropbox.com/scl/fi/wtr98gk7uqz57s3oupmtp/Ripchord-Subtle-Radio.mp3?rlkey=84q90f7dstpk2330gsbdg1tnm&st=cgntnpzs&dl=1",
      cover: "image/radio/brazilian/karani.jpg"
    },
  ],

  
  miercoles: [
    {
      id: "brazilian-012",
      startTime: "07:50",
      endTime: "08:30",
      title: "GlitterTape - Camoufly",
      description: "Flow FanYYYYY",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/id2025.jpg"
    },
    {
      id: "brazilian-013",
      startTime: "21:20",
      endTime: "21:50",
      title: "ID Breaks 2025",
      description: "Break Beat Drops 2025.",
      color: "#c6d406",
      src: "https://dl.dropbox.com/scl/fi/g66tiyv2arfbho4zms6tp/ID-MIX-2025.mp3?rlkey=0kr6f6k4f5izcwjdnuri8mvo0&dl=1",
      cover: "image/radio/id2025.jpg"
    },
    {
      id: "brazilian-0131",
      startTime: "10:50",
      endTime: "11:50",
      title: "Ripchord - Karan!",
      description: "Flow FanYYYYY",
      color: "#36bd36",
      src: "https://dl.dropbox.com/scl/fi/wtr98gk7uqz57s3oupmtp/Ripchord-Subtle-Radio.mp3?rlkey=84q90f7dstpk2330gsbdg1tnm&st=cgntnpzs&dl=1",
      cover: "image/radio/brazilian/karani.jpg"
    },
    {
      id: "brazilian-0131",
      startTime: "16:00",
      endTime: "17:00",
      title: "Ripchord - Karan!",
      description: "Flow FanYYYYY",
      color: "#36bd36",
      src: "https://dl.dropbox.com/scl/fi/wtr98gk7uqz57s3oupmtp/Ripchord-Subtle-Radio.mp3?rlkey=84q90f7dstpk2330gsbdg1tnm&st=cgntnpzs&dl=1",
      cover: "image/radio/brazilian/karani.jpg"
    },
  ],
jueves: [
  {
    id: "brazilian-014",
    startTime: "21:20",
    endTime: "21:50",
    title: "ID Breaks 2025",
    description: "Break Beat Drops 2025.",
    color: "#c6d406",
    src: "https://dl.dropbox.com/scl/fi/g66tiyv2arfbho4zms6tp/ID-MIX-2025.mp3?rlkey=0kr6f6k4f5izcwjdnuri8mvo0&dl=1",
    cover: "image/radio/id2025.jpg"
  },
  {
      id: "brazilian-0131",
      startTime: "01:10",
      endTime: "02:00",
      title: "Ripchord - Karan!",
      description: "Flow FanYYYYY",
      color: "#36bd36",
      src: "https://dl.dropbox.com/scl/fi/wtr98gk7uqz57s3oupmtp/Ripchord-Subtle-Radio.mp3?rlkey=84q90f7dstpk2330gsbdg1tnm&st=cgntnpzs&dl=1",
      cover: "image/radio/brazilian/karani.jpg"
    },
],
  viernes: [
    {
      id: "brazilian-015",
      startTime: "10:00",
      endTime: "10:30",
      title: "Estrenos Mixtape",
      description: "Lo nuevo nuevo de las listas M®",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/0-2/chill-house/cover.jpg"
    },
    {
      id: "brazilian-0133",
      startTime: "10:30",
      endTime: "11:30",
      title: "Ripchord - Karan!",
      description: "Flow FanYYYYY",
      color: "#36bd36",
      src: "https://dl.dropbox.com/scl/fi/wtr98gk7uqz57s3oupmtp/Ripchord-Subtle-Radio.mp3?rlkey=84q90f7dstpk2330gsbdg1tnm&st=cgntnpzs&dl=1",
      cover: "image/radio/brazilian/karani.jpg"
    },
  ],


  sabado: [
    {
      id: "brazilian-0132",
      startTime: "16:00",
      endTime: "17:10",
      title: "Ripchord - Karan!",
      description: "Flow FanYYYYY",
      color: "#36bd36",
      src: "https://dl.dropbox.com/scl/fi/wtr98gk7uqz57s3oupmtp/Ripchord-Subtle-Radio.mp3?rlkey=84q90f7dstpk2330gsbdg1tnm&st=cgntnpzs&dl=1",
      cover: "image/radio/brazilian/karani.jpg"
    },
    {
      id: "brazilian-0164",
      startTime: "19:10",
      endTime: "20:00",
      title: "ID Breaks",
      description: "Break Beat Drops 2025.",
      color: "#c6d406",
      src: "https://dl.dropbox.com/scl/fi/g66tiyv2arfbho4zms6tp/ID-MIX-2025.mp3?rlkey=0kr6f6k4f5izcwjdnuri8mvo0&dl=1",
      cover: "image/radio/id2025.jpg"
    },
  ],


  domingo: [
    {
      id: "brazilian-0133",
      startTime: "14:30",
      endTime: "15:30",
      title: "Ripchord - Karan!",
      description: "Flow FanYYYYY",
      color: "#36bd36",
      src: "https://dl.dropbox.com/scl/fi/wtr98gk7uqz57s3oupmtp/Ripchord-Subtle-Radio.mp3?rlkey=84q90f7dstpk2330gsbdg1tnm&st=cgntnpzs&dl=1",
      cover: "image/radio/brazilian/karani.jpg"
    },
  ]
};